/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M15 6l-6 6l6 6", "key": "svg-0" }]];
const IconChevronLeft = createReactComponent("outline", "chevron-left", "ChevronLeft", __iconNode);

export { __iconNode, IconChevronLeft as default };
//# sourceMappingURL=IconChevronLeft.mjs.map
